import { buildManagedUtilityClasses } from '@smoothie-framework/ui-styles/styling';
import { getTheme } from '../../theme/theme_context';
const RECIPE_UTILITY_PROP_COLLISIONS = {
    Divider: new Set(['background', 'backgroundColor']),
    Tabs: new Set(['value', 'defaultValue', 'activationMode', 'loopFocus', 'lazyMount', 'unmountOnExit']),
    TabsTrigger: new Set(['value']),
    TabsContent: new Set(['value']),
    Accordion: new Set(['value', 'defaultValue']),
    AccordionItem: new Set(['value']),
    Heading: new Set(['color']),
    TableCell: new Set(['colSpan', 'rowSpan', 'sticky']),
    TableColumnHeader: new Set(['colSpan', 'rowSpan', 'sticky']),
    Text: new Set(['color']),
};
const EMPTY_UTILITY_PROP_COLLISIONS = new Set();
export function resolveClassNames(type, props, theme = getTheme()) {
    if (!type) {
        return { className: undefined, typeClasses: [] };
    }
    const classes = [];
    const baseClass = resolveClassNameValue(props.className);
    if (baseClass) {
        classes.push(...baseClass.split(' ').filter((item) => item));
    }
    else {
        classes.push(`smth-${kebabCase(String(type))}`);
        switch (type) {
            case 'Stack':
                classes.push('smth-stack');
                break;
            case 'StackRow':
                classes.push('smth-stack-row');
                break;
            case 'StackCol':
                classes.push('smth-stack-col');
                break;
            case 'Button':
                classes.push('smth-button');
                break;
        }
    }
    const typeClasses = [];
    const excludedUtilityProps = RECIPE_UTILITY_PROP_COLLISIONS[type] ?? EMPTY_UTILITY_PROP_COLLISIONS;
    for (const utilityClass of buildManagedUtilityClasses(props, excludedUtilityProps, theme)) {
        classes.push(utilityClass);
    }
    const deduped = Array.from(new Set(classes));
    return {
        className: deduped.length > 0 ? deduped.join(' ') : undefined,
        typeClasses,
    };
}
function resolveClassNameValue(value) {
    if (typeof value === 'function') {
        return resolveClassNameValue(value());
    }
    if (Array.isArray(value)) {
        const resolved = value
            .map((entry) => resolveClassNameValue(entry))
            .filter((entry) => Boolean(entry));
        return resolved.length > 0 ? resolved.join(' ') : undefined;
    }
    return typeof value === 'string' ? value : undefined;
}
export function applyClassNames(element, type, props, theme) {
    const { className, typeClasses } = resolveClassNames(type, props, theme);
    if (className) {
        element.setAttribute('class', className);
    }
    else {
        element.removeAttribute('class');
    }
    if (typeClasses.length > 0) {
        element.classList.add(...typeClasses);
    }
}
function kebabCase(value) {
    return value.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}
//# sourceMappingURL=classnames.js.map